// 自动写入，请勿在此处修改
export const primaryColor = "rgb(21, 157, 225)";